const actionsType = {
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAIL: "REGISTER_FAIL",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  LOGOUT: "LOGOUT",
  CLEAR_MESSAGE: "CLEAR_MESSAGE",

  // App
  GET_CATEGORIES: "GET_CATEGORIES",
  GET_DETAIL_PRODUCT: "GET_DETAIL_PRODUCT",
  GET_PRODUCT_LISTCART: "GET_PRODUCT_LISTCART",
  GET_INFO_REVIEWS: "GET_INFO_REVIEWS",
  GET_REVIEWS_PRODUCT: "GET_REVIEWS_PRODUCT",
  GET_PRODUCT_CATEGORY: "GET_PRODUCT_CATEGORY",
  GET_TOTAL_PRODUCT_CATEGORY: "GET_TOTAL_PRODUCT_CATEGORY",

  // user
  GET_USER: "GET_USER",
};

export default actionsType;
